import { useEffect, useState } from "react";

/**
 * False on the server and on the first client render, true after mount. Open Home's member-only
 * UI reads the session token from a cookie the server render never sees, so anything that
 * depends on it waits for this flag: server HTML and the first client render stay identical
 * (React #418 otherwise, and a hydration re-render that swallowed first clicks).
 */
export const useMounted = () => {
  const [mounted, setMounted] = useState(false);

  useEffect(() => setMounted(true), []);

  return mounted;
};
